<template>
  <div>
    <pagination
      v-loading="loading"
      :data="employeeListData"
      :option="paginationOption"
      @search="search"
      @add="add"
      @edit="edit"
    ></pagination>
    <el-dialog
      :close-on-click-modal="false"
      width="700px"
      :visible.sync="dialogEditorVisible"
      top="8vh"
    >
      <receptionistEdit
        :category="category"
        :data="editData"
        @closeDialog="onCloseEditor"
        @saveSuccess="onSaveSuccess"
      ></receptionistEdit>
    </el-dialog>
  </div>
</template>

<script>
import pagination from "../common/pagination";
import receptionistEdit from "./receptionistEdit";
import { getEmployees } from "../../service/user.service";
export default {
  props: {
    category: {
      //1-行政, 2-财务, 3-真留
      type: [Number, String],
      default: 1,
      validator: (value) => {
        let strValue = `${value}`;
        return ["1", "2", "3"].contains(strValue);
      }
    }
  },
  data() {
    return {
      loading: false,
      listData: [],
      employeeListData: [],
      paginationOption: {},
      editData: {},
      editIndex: -1,
      dialogEditorVisible: false,
      searchKeyword: "",
      roleTypes: [],
    };
  },
  components: {
    pagination,
    receptionistEdit,
  },
  created() {
    let roleName = "";
    switch (`${this.category}`) {
      case "2":
        roleName = "财务";
        this.roleTypes = this.GLOBAL.roleType.getOptionsByType(roleName).map(enumOption => enumOption.value);
        break;
      case "3":
        roleName = "真留";
        let type2;
        if (this.USERMANAGER.isSABusiness)
          type2 = "业务";
        else if (this.USERMANAGER.isSAFinancial)
          type2 = "财务";
        this.roleTypes = this.GLOBAL.roleType.getOptionsByType(roleName, type2).map(enumOption => enumOption.value);
        break;
      default:
        roleName = "行政";
        this.roleTypes = this.GLOBAL.roleType.getOptionsByType("前台").map(enumOption => enumOption.value);
        break;
    }
  
    this.getEmployeeListData("");

    let hasEditButton = false;
    if (`${this.category}` !== "3") {
      hasEditButton = this.USERMANAGER.isManager || this.USERMANAGER.isAdmin || this.USERMANAGER.isPersonnelManagement;
    } else {
      hasEditButton = this.USERMANAGER.isAdmin || this.USERMANAGER.isSAManager;
    }
    this.paginationOption = {
      displayPagination: false,
      hasEditButton,
      editButtonText: "编辑账号",
      hasAddButton: true,
      addButtonText: "添加" + roleName,
      hasSearch: true,
      showUniversityGroup: `${this.category}` !== "3",
      showTrainingCategory: `${this.category}` !== "3",
      showChannelsText: `${this.category}` === "3",
      fnRowEditVisible: this.onRowEditVisible,
    };
  },
  methods: {
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
    onSaveSuccess(isAdd, row) {
      this.dialogEditorVisible = false;
      // let listData = this.employeeListData;
      // if (isAdd){
      //   listData.Results.unshift(row);
      // }else{
      //   listData.Results[this.editIndex] = row;
      // }
      // this.employeeListData = listData;
      this.getEmployeeListData(this.searchKeyword);
    },
    search(keyword) {
      this.searchKeyword = keyword;
      this.getEmployeeListData(keyword);
    },
    add() {
      this.editData = {};
      this.dialogEditorVisible = true;
    },
    edit(index, row) {
      this.editIndex = index;
      this.editData = row;
      this.dialogEditorVisible = true;
    },
    getEmployeeListData(keyword) {
      this.loading = true;

      getEmployees(this.roleTypes, keyword, null).then((result) => {
        if (result && result.success) {
          this.employeeListData = result.data;
        }
        this.loading = false;
      });
    },
    onRowEditVisible(index, row) {
      if (this.USERMANAGER.isAdmin || this.USERMANAGER.isPersonnelManagement) return true;

      if (`${this.category}` !== "3") {
        if (!this.USERMANAGER.isManager) return false;
        return row.RoleId !== this.GLOBAL.roleType.executiveManager && row.RoleId !== this.GLOBAL.roleType.financialManager;
      } else {
        if (this.USERMANAGER.isSAManager) {
          let type2, exceptKeys;
          if (this.USERMANAGER.isSABusiness) {
            type2 = "业务";
            exceptKeys = ["saBusinessManager"];
          } else if (this.USERMANAGER.isSAFinancial) {
            type2 = "财务";
            exceptKeys = ["saFinancialManager"];
          }

          if (!!type2) {
            return this.GLOBAL.roleType.getOptionsByType("真留", type2, exceptKeys).some(enumOption => enumOption.value === row.RoleId);
          }
        }

        return false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/receptionist/receptionistList.vue